import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/growmaxlogo11.png";
// import logo1 from "../assets/BuildproOgcs.png";
import logo1 from "../assets/OgcsLogo.png";

const navItems = [
  { to: "/about", label: "About Us" },
  { to: "/programs", label: "Programs" },
  { to: "/event", label: "Events" },
  { to: "/gallery", label: "Gallery" },
  { to: "/review", label: "Review" },
  { to: "/contact", label: "Contact" },
  { to: "/blogs", label: "Blogs" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const linkBase =
    "relative group px-3 py-2 text-[15px] font-medium rounded-lg tracking-wide transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300";
  const linkActive =
    "text-slate-900 after:scale-x-100 after:opacity-100";
  const linkInactive =
    "text-slate-600 hover:text-slate-900";

  // gradient underline (hover/active)
  const underline =
    "after:absolute after:left-2 after:right-2 after:-bottom-0.5 after:h-0.5 after:rounded-full " +
    "after:bg-gradient-to-r after:from-sky-500 after:to-indigo-500 " +
    "after:transition-transform after:duration-300 after:origin-center " +
    "after:opacity-0 after:scale-x-0 group-hover:after:opacity-100 group-hover:after:scale-x-100";

  return (
    <header className="sticky top-0 z-50">
      {/* Subtle accent bar */}
      <div className="h-0.5 w-full bg-gradient-to-r from-sky-400 via-cyan-400 to-indigo-500 " />

      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Glassy container */}
        <div className="mt-2 mb-2 rounded-2xl border border-white/60 bg-white/80 backdrop-blur supports-[backdrop-filter]:backdrop-blur shadow-[0_6px_30px_-18px_rgba(2,6,23,0.35)]">
          {/* Top row */}
          <div className="flex h-16 items-center justify-between px-3 sm:px-4">
            {/* Left: brand */}
            <div className="flex items-center gap-2">
              <Link
                to="/"
                aria-label="Go to Growmax home"
                className="inline-flex items-center"
              >
                <img
                  src={logo}
                  alt="Growmax"
                  className="h-12 w-auto object-contain"
                />
              </Link>
            </div>

            {/* Desktop nav */}
            <div className="hidden md:flex items-center gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `${linkBase} ${underline} ${isActive ? linkActive : linkInactive}`
                  }
                >
                  {item.label}
                </NavLink>
              ))}

              {/* CTA */}
              <Link
                to="/booking"
                className="ml-2 inline-flex items-center rounded-xl px-4 py-2 text-sm font-semibold text-white 
                           bg-gradient-to-r from-sky-500 to-indigo-600 shadow-sm hover:shadow 
                           ring-1 ring-sky-500/30 hover:brightness-105 transition-all focus-visible:ring-2 focus-visible:ring-sky-300"
              >
                Book Now
              </Link>

              {/* External logo */}
              <a
                href="https://buildpro.ogcs.co.in/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open BuildPro-OGCS website"
                title="Open BuildPro-OGCS website"
                className="ml-3 inline-flex items-center rounded-lg ring-1 ring-transparent hover:ring-slate-200 transition"
              >
                <img
                  src={logo1}
                  alt="BuildPro-OGCS"
                  className=" w-32 object-contain h-16"
                />
              </a>
            </div>

            {/* Mobile burger */}
            <button
              onClick={() => setOpen((v) => !v)}
              className="md:hidden inline-flex items-center justify-center rounded-lg p-2 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300"
              aria-label="Toggle menu"
              aria-expanded={open}
            >
              <svg
                className="h-6 w-6 text-slate-800"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                {open ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile drawer */}
          <div
            className={`md:hidden overflow-hidden transition-[max-height] duration-300 ${open ? "max-h-97" : "max-h-0"}`}
          >
            <div className="px-3 sm:px-4 pb-4">
              <div className="grid grid-cols-1 gap-1 mt-2">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `w-full ${linkBase} ${isActive ? "text-slate-900 bg-slate-100" : "text-slate-700 hover:bg-slate-50"}`
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
                <Link
                  to="/booking"
                  onClick={() => setOpen(false)}
                  className="mt-1 inline-flex w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white 
                             bg-gradient-to-r from-sky-500 to-indigo-600 shadow-sm hover:shadow ring-1 ring-sky-500/30 
                             transition-all focus-visible:ring-2 focus-visible:ring-sky-300"
                >
                  Book Now
                </Link>

                <a
                  href="https://buildpro.ogcs.co.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open BuildPro-OGCS website"
                  title="Open BuildPro-OGCS website"
                  className="mt-2 inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white/70 px-3 py-2 hover:bg-white transition"
                >
                  <img
                    src={logo1}
                    alt="BuildPro-OGCS"
                    className="h-10 w-28 object-contain"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;





